
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import MothersDay_defaultSection from "./MothersDay_defaultSection.vue";

export default defineComponent({
  components: {
    MothersDay_defaultSection
  },
  name: "MothersDay_cocktailsSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menuVersion: {
      type: String,
      default: ''
    },
    sectionModifier: {
      type: String,
      default: ''
    },
    menu: {
      type: Object as PropType<Menu | null>,
      required: true
    }
  },
})
